<p>ex-register works!</p>
